export const Other = Object.freeze({
  id: -1,
  name: "Otros"
});
